<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="6">
          <b-button
            class="mr-5"
            :variant="(filterStatus == 'approved' ? '' : 'outline-') + 'success'"
            @click="
              filterStatus == 'approved'
                ? (filterStatus = '')
                : (filterStatus = 'approved')
            "
          >
            {{ $t("Approved") }}
          </b-button>
          <b-button
            class="mr-5"
            :variant="(filterStatus == 'pending' ? '' : 'outline-') + 'warning'"
            @click="
              filterStatus == 'pending' ? (filterStatus = '') : (filterStatus = 'pending')
            "
          >
            {{ $t("Pending") }}
          </b-button>
          <b-button
            class="mr-5"
            :variant="(filterStatus == 'rejected' ? '' : 'outline-') + 'danger'"
            @click="
              filterStatus == 'rejected'
                ? (filterStatus = '')
                : (filterStatus = 'rejected')
            "
          >
            {{ $t("Rejected") }}
          </b-button>
        </b-col>
        <b-col cols="6"><b-form-input
          v-model="searchUser"
          class="d-inline-block mr-1"
          :placeholder="$t('Search')"
        />
        </b-col>
      </b-row>
      <b-table
        small
        responsive
        hover
        class="mt-3"
        :items="approvalsComputed"
        :fields="fields"
        :tbody-tr-class="rowClass"
        primary-key="id"
      >
        <template #head(_id)>
          <span style="display: none">{{ $t("ID") }}</span>
        </template>
        <template #cell(_id)>
          <!-- <span>{{ data.item._id }}</span> -->
        </template>
        <template #head(for)>
          <span>{{ $t("User") }}</span>
        </template>
        <template #head(status)>
          <span>{{ $t("Status") }}</span>
        </template>
        <template #cell(for)="data">
          <b-link v-if="data.item.type == 'profile'">
            <!-- :to="{
              name: 'approval-profile',
              params: { id: data.item.for._id },
            }"
            target="_blank" -->
            <b-button
              variant="primary"
              @click="
                viewId = data.item.for._id;
                $refs.profileModal.show();
              "
            >{{ data.item.for.displayName }}</b-button>
          </b-link>
          <b-link v-else>
            <!-- :to="{
              name: 'approval-account',
              params: { id: data.item.for._id },
            }"
            target="_blank" -->
            <b-button
              variant="primary"
              @click="
                viewId = data.item.for._id;
                $refs.accountModal.show();
                viewDocuments = data.item.documents;
              "
            >{{ data.item.for.displayName }}</b-button>
          </b-link>
        </template>
        <template #head(type)>
          <span>{{ $t("Type") + " " + $t("And") + " " + $t("Documents") }}</span>
        </template>
        <template #cell(type)="data">
          <span>{{ $t(data.item.type) }}</span>
          <!--<b-button
            v-for="document in data.item.documents"
            :href="document"
            target="_blank"
            variant="primary"
            class="ml-1"
          >
            <FeatherIcon icon="SearchIcon" />
          </b-button> -->
        </template>
        <template #cell(daysSinceSubscribed)="data">
          <span v-if="data.item.reviewTiming.state === 'not-applicable'">
            {{ $t('adminApproval.reviewNotApplicable') }}
          </span>
          <span v-else-if="data.item.daysSinceSubscribed == null">{{ $t('Başlamadı') }}</span>
          <b-badge
            v-else
            :variant="daysBadgeVariant(data.item.daysSinceSubscribed)"
          >
            {{ data.item.daysSinceSubscribed }} / 15
          </b-badge>
        </template>
        <template #cell(createdAt)="data">
          <time :datetime="dateTimeValue(data.item.createdAt)">
            {{ formatDateTime(data.item.createdAt) }}
          </time>
        </template>
        <template #cell(subscriptionStartedAt)="data">
          <span v-if="!data.item.reviewTiming.startedAt">{{ $t('Başlamadı') }}</span>
          <time
            v-else
            :datetime="dateTimeValue(data.item.reviewTiming.startedAt)"
          >
            {{ formatDateTime(data.item.reviewTiming.startedAt) }}
          </time>
        </template>
        <template #cell(reviewDeadlineAt)="data">
          <span v-if="data.item.reviewTiming.state === 'not-applicable'">
            {{ $t('adminApproval.reviewNotApplicable') }}
          </span>
          <span v-else-if="!data.item.reviewTiming.deadlineAt">—</span>
          <span v-else>
            <time :datetime="dateTimeValue(data.item.reviewTiming.deadlineAt)">
              {{ formatDateTime(data.item.reviewTiming.deadlineAt) }}
            </time>
            <small class="d-block text-muted">{{ $t(reviewStateLabel(data.item.reviewTiming.state)) }}</small>
          </span>
        </template>
        <template #cell(subscriptionStatus)="data">
          <span>{{ (data.item.for && data.item.for.subscriptionStatus) || '—' }}</span>
        </template>
        <template #cell(status)="data">
          <b-badge
            v-if="data.item.status == 'pending'"
            variant="warning"
          >
            {{ $t(data.item.status) }}
          </b-badge>
          <b-badge
            v-else
            :variant="data.item.status == 'approved' ? 'success' : 'danger'"
          >
            {{ $t(data.item.status) }}
          </b-badge>
          <small
            v-if="isStickyApproved(data.item)"
            class="d-block text-success"
          >{{ $t('adminApproval.stickyApproval') }}</small>
        </template>
        <template #cell(actions)="data">
          <div v-if="data.item.status == 'pending'">
            <b-button
              v-b-modal.approveModal
              class="btn-icon m-1"
              variant="success"
              @click="selectReview(data.item._id)"
            >
              <feather-icon icon="CheckCircleIcon" />
            </b-button>
            <b-button
              v-b-modal.rejectModal
              variant="danger"
              class="btn-icon m-1"
              @click="selectReview(data.item._id)"
            >
              <feather-icon icon="XCircleIcon" />
            </b-button>
          </div>
          <b-button
            v-if="$can('manage', 'all')"
            class="btn-icon m-1 block-toggle"
            :variant="data.item.for && data.item.for.accountBlocked ? 'outline-danger' : 'danger'"
            :title="data.item.for && data.item.for.accountBlocked ? $t('Unblock Account') : $t('Block Account')"
            @click="toggleBlock(data.item)"
          >
            <feather-icon :icon="data.item.for && data.item.for.accountBlocked ? 'UnlockIcon' : 'SlashIcon'" />
          </b-button>
        </template>
      </b-table>
    </b-card>
    <b-modal
      id="approveModal"
      ref="approveModal"
      centered
      hide-footer
      @hide="hiddenModal"
    >
      <span>{{ $t("Review Comment") }}</span>
      <b-form-textarea v-model="comment" />
      <b-button
        variant="primary"
        class="mt-1"
        :disabled="reviewInFlight"
        @click="review(true)"
      >{{ $t("Approve")
      }}</b-button>
    </b-modal>
    <b-modal
      id="rejectModal"
      ref="rejectModal"
      centered
      hide-footer
      @hide="hiddenModal"
    >
      <span>{{ $t("Review Comment") }}</span>
      <b-form-textarea
        v-model="comment"
        :maxlength="maxRejectionReasonLength"
        :state="rejectionReasonState"
        aria-describedby="reject-reason-feedback"
        @input="rejectionAttempted = false"
      />
      <b-form-invalid-feedback id="reject-reason-feedback">
        {{ $t('Reddetme işlemi için açıklayıcı bir inceleme notu yazın.') }}
      </b-form-invalid-feedback>
      <b-button
        variant="danger"
        class="mt-1"
        :disabled="!canReject || reviewInFlight"
        @click="review(false)"
      >{{ $t("Reject")
      }}</b-button>
    </b-modal>
    <b-modal
      ref="accountModal"
      size="xl"
      hide-footer
      @hide="
        viewId = null;
        viewDocuments = [];
      "
    >
      <account-view
        v-if="viewId"
        :id="viewId"
        :documents="viewDocuments"
      />
    </b-modal>
    <b-modal
      ref="profileModal"
      hide-footer
      size="xl"
      @hide="viewId = null"
    >
      <profile-view
        v-if="viewId"
        :id="viewId"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BLink,
  BModal,
  BCard,
  BBadge,
  BCol,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
  BRow,
} from 'bootstrap-vue'
import axios from '@axios'
import { formatApprovalLifecycleDate } from '@/libs/approvalLifecycle'
import { deriveAdminApprovalTiming } from '@/libs/adminApprovalTiming'
import { OTP_ERROR_KEYS_BY_CODE } from '@/libs/otpI18nKeys'

import ProfileView from './Profile.vue'
import AccountView from './Account.vue'

const {
  axiosRoutes: { approval: path, user: userPath },
} = require('../../../../G_CONFIG')

export default {
  components: {
    BTable,
    BRow,
    BButton,
    BLink,
    BModal,
    BCard,
    BBadge,
    BCol,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    ProfileView,
    AccountView,
  },

  data() {
    return {
      approvalList: null,
      searchUser: '',
      activeId: null,
      viewId: null,
      comment: '',
      rejectionAttempted: false,
      reviewInFlight: false,
      maxRejectionReasonLength: 1000,
      viewDocuments: [],
      filterStatus: 'pending',
      fields: [
        {
          key: '_id', label: 'ID', sortable: false, visible: false,
        },
        { key: 'for', label: this.$t('User'), sortable: true },
        { key: 'type', label: this.$t('Type'), sortable: true },
        { key: 'status', label: this.$t('Status'), sortable: true },
        { key: 'createdAt', label: this.$t('Başvuru Gönderim Tarihi'), sortable: true },
        { key: 'subscriptionStartedAt', label: this.$t('Abonelik Başlangıcı'), sortable: true },
        { key: 'reviewDeadlineAt', label: this.$t('Değerlendirme Son Tarihi'), sortable: true },
        { key: 'subscriptionStatus', label: this.$t('Abonelik Durumu'), sortable: true },
        { key: 'daysSinceSubscribed', label: this.$t('Days Since Subscribed'), sortable: true },
        { key: 'actions', label: this.$t('Actions'), sortable: false },
      ],
    }
  },
  computed: {
    trimmedComment() {
      return typeof this.comment === 'string' ? this.comment.trim() : ''
    },
    canReject() {
      return this.trimmedComment.length > 0
        && this.trimmedComment.length <= this.maxRejectionReasonLength
    },
    rejectionReasonState() {
      if (!this.rejectionAttempted && !this.comment) return null
      return this.canReject
    },
    approvalsComputed() {
      let tempList = this.approvalList
      if (this.filterStatus && tempList) {
        tempList = tempList.filter(item => item.status === this.filterStatus)
      }
      if (this.searchUser && tempList) {
        tempList = tempList.filter(item => item.for.displayName.toLowerCase().includes(this.searchUser.toLowerCase()))
      }
      return tempList
    },
  },
  async created() {
    await this.loadApprovals()
  },
  methods: {
    normalizeApprovalRows(data) {
      return data.map(item => {
        const reviewTiming = deriveAdminApprovalTiming(item)
        return {
          ...item,
          documents: (item.documents || []).map(doc => axios.defaults.baseURL + doc),
          reviewTiming,
          subscriptionStartedAt: reviewTiming.startedAt,
          reviewDeadlineAt: reviewTiming.deadlineAt,
          subscriptionStatus: item.for && item.for.subscriptionStatus,
        }
      })
    },
    async loadApprovals() {
      const { data } = await axios.get(path.getAll)
      this.approvalList = this.normalizeApprovalRows(data)
    },
    selectReview(id) {
      this.activeId = id
      this.comment = ''
      this.rejectionAttempted = false
    },
    async review(status) {
      if (!status) {
        this.rejectionAttempted = true
        if (!this.canReject) return
      }
      if (this.reviewInFlight) return
      this.reviewInFlight = true
      try {
        const response = await axios.patch(`${path.edit}/${this.activeId}`, {
          status: status ? 'approved' : 'rejected',
          comment: status ? this.comment : this.trimmedComment,
        })
        const grant = response && response.data && response.data.freeAccessGrant
        if (status && grant) {
          this.$bvToast.toast(this.$t(grant.granted ? 'adminApproval.freeAccessGranted' : 'adminApproval.freeAccessNotGranted', {
            date: formatApprovalLifecycleDate(grant.endsAt),
          }), { title: 'Ücretsiz Kullanım', variant: grant.granted ? 'success' : 'info', solid: true })
        }
        await this.loadApprovals()
        this.$refs.approveModal.hide()
        this.$refs.rejectModal.hide()
      } catch (err) {
        this.toastErr(err, this.$t('Could not update the application'))
      } finally {
        this.reviewInFlight = false
      }
    },
    dateTimeValue(value) {
      if (!value) return null
      const date = value instanceof Date ? value : new Date(value)
      return Number.isNaN(date.getTime()) ? null : date.toISOString()
    },
    formatDateTime(value) {
      const iso = this.dateTimeValue(value)
      if (!iso) return '—'
      return new Date(iso).toLocaleString('tr-TR', {
        timeZone: 'Europe/Istanbul',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    reviewStateLabel(state) {
      if (state === 'not-applicable') return 'adminApproval.reviewNotApplicable'
      return state === 'completed' ? 'Süre tamamlandı' : 'Süre devam ediyor'
    },
    daysBadgeVariant(days) {
      if (days >= 11) return 'danger'
      if (days >= 6) return 'warning'
      return 'secondary'
    },
    rowClass(item) {
      if (!item) return ''
      // Rejected application on a live subscription: the charge-guard clock
      // is running against this user. Sticky approval makes that clock
      // non-applicable even when the latest display row needs correction.
      return item.status === 'rejected'
        && item.for
        && item.for.subscriptionStartedAt
        && !this.isEverApproved(item)
        ? 'table-danger'
        : ''
    },
    isEverApproved(item) {
      const user = item && item.for
      return Boolean(user && (user.approved === true || user.firstApprovedAt != null))
    },
    isStickyApproved(item) {
      return Boolean(item && item.status === 'rejected' && this.isEverApproved(item))
    },
    toggleBlock(item) {
      const forUser = item.for || {}
      const blocked = !forUser.accountBlocked
      const label = blocked ? this.$t('Block Account') : this.$t('Unblock Account')
      this.$bvModal.msgBoxConfirm(`${label}: ${forUser.displayName}`, {
        title: label,
        okVariant: blocked ? 'danger' : 'primary',
        okTitle: label,
        cancelTitle: this.$t('Cancel'),
        centered: true,
      }).then(confirmed => {
        if (!confirmed) return
        const { _id: forUserId } = forUser
        axios
          .patch(`${userPath.approvalBlock}/${forUserId}/approval-block`, { blocked })
          .then(({ data }) => {
            // GET /approval rows are not promised to carry for.accountBlocked;
            // the PATCH response is the source of truth.
            this.$set(item.for, 'accountBlocked', data.accountBlocked)
            this.$bvToast.toast(forUser.displayName || '', {
              title: label,
              variant: 'success',
              solid: true,
            })
          })
          .catch(err => this.toastErr(err, this.$t('Could not update the application')))
      })
    },
    toastErr(err, fallback) {
      const data = (err && err.response && err.response.data) || null
      // L5: a mapped error code wins over the server's own sentence, which is
      // English and unlocalized. 400026 (rejection reason required) is the one
      // this screen can actually produce.
      const mapped = data && OTP_ERROR_KEYS_BY_CODE[Number(data.errorCode)]
      if (mapped) {
        // Re-arm the modal's own validation so the reviewer sees WHICH field
        // to fix, not just a toast that disappears.
        if (Number(data.errorCode) === 400026) this.rejectionAttempted = true
        this.$bvToast.toast(this.$t(mapped), {
          title: this.$t('Error'),
          variant: 'danger',
          solid: true,
        })
        return
      }
      const msg = (data && (data.message || data.error))
        || (err && err.message)
        || fallback
      this.$bvToast.toast(msg, {
        title: this.$t('Error'),
        variant: 'danger',
        solid: true,
      })
    },
    hiddenModal() {
      this.activeId = null
      this.comment = ''
      this.rejectionAttempted = false
    },
  },
}
</script>
<style scoped></style>
